// extracted by mini-css-extract-plugin
module.exports = {"signupContainer":"styles_signupContainer__2G3NC","tabs":"styles_tabs__2V4Ph","signupHeader":"styles_signupHeader__3jAIV","formMessages":"styles_formMessages__2dqGY"};